import * as React from 'react';
import * as moment from "moment";
import { safe, isNullOrUndefined, isNullOrEmpty, getPerformanceForCompare, addItemToGoogleTracking } from "../../utils";
import { IPageProperties } from "../../models";
import { BackToTop } from "../../assets/BackToTop/BackToTop";
import { PerformanceChart } from "../FundPages/PerformanceChart";
import { IDataEntity, IAppParams, IGoogleEvent } from "../../models";
import { Tabs } from "../../assets/Tabs/Tabs";
import { TabContents } from "../../assets/TabContents/TabContents";
import { Tooltip } from "../../assets/Tooltip/Tooltip";
import { Search } from "../Search/Search";
import { ResponsiveContainer } from "../ResponsiveContainer/ResponsiveContainer";
import { Selector } from "../Selector/Selector";
import { CategorySelector } from "./CategorySelector/CategorySelector";
import { NumberFormat, Disclaimer } from "../../assets/";

const overrideStyles = require('./overrides/TabStylesOverride.pcss');
const selectorOverrideStyles = require('./overrides/selectorOverrideStyles.pcss');
const styles = require('./styles.pcss');
const backToTopstyles = require('./overrides/BackToTopoverride.pcss');
// tslint:disable-next-line:variable-name
const AddBtn = require('react-icons/lib/fa/plus');
// tslint:disable-next-line:variable-name
const CloseBtn = require('react-icons/lib/fa/close');
const searchBarStyles = require('./overrides/mainSearch.pcss');
// tslint:disable-next-line:variable-name
const Datetime = require('react-datetime');

interface IProps {
	Opened?: boolean;
	shareClass?: IDataEntity;
	colSpan?: number;
	appParams?: IAppParams;
	fund?: IDataEntity;
}

interface IState {
	shareAge?: number;
	activeTab?: number;
	isHovering?: boolean;
	selectedTimeFilter?: number;
	startDate?: any;
	endDate?: any;
	selectedIndex?: number;
	selectedBenchmarkSector?: {
		identifier?: string;
		text?: string;
	};
	showMaxCompareMessage?: boolean;
	compareMessage?: {
		__html: any;
	};
	launchDate?: null | string;
}

interface IFilterOptions {
	text: string;
	value: string;
}

export class PagePerformance extends React.Component<IPageProperties, IState>{
	constructor(props) {
		super(props);

		this.state = {
			activeTab: 0,
			shareAge: 0,
			selectedTimeFilter: 999,
			selectedIndex: 0,
			selectedBenchmarkSector: {
				identifier: "",
				text: ""
			},
			showMaxCompareMessage: false,
			endDate: moment().endOf("month"),
			launchDate: null
		};

		this.handleTabClick = this.handleTabClick.bind(this);
		this.setStartDate = this.setStartDate.bind(this);
		this.setEndDate = this.setEndDate.bind(this);
		this.checkDate = this.checkDate.bind(this);
		this.addShareToCompare = this.addShareToCompare.bind(this);
		this.addBMToCompare = this.addBMToCompare.bind(this);
		this.removeFromCompare = this.removeFromCompare.bind(this);
		this.getBenchmarkOrSectorValues = this.getBenchmarkOrSectorValues.bind(this);
		this.changeSelectedIndex = this.changeSelectedIndex.bind(this);
		this.selectBenchmarkSector = this.selectBenchmarkSector.bind(this);
		this.showMaxCompareMessage = this.showMaxCompareMessage.bind(this);
		this.hideMaxCompareMessage = this.hideMaxCompareMessage.bind(this);
		this.checkIfAlreadyInCompare = this.checkIfAlreadyInCompare.bind(this);
		this.handleSelectedTimeClick = this.handleSelectedTimeClick.bind(this);
		this.checkShareAge = this.checkShareAge.bind(this);
	};

	componentDidUpdate() {
		let { appParams, shareClass } = this.props;
		if (isNullOrEmpty(this.props.compare)) {
			this.props.primeCompareCollection(appParams);
		}
		if (isNullOrUndefined(this.state.launchDate)) {
			let launchDate = shareClass.properties.launch_date;
			let shareAge = moment().diff(moment(launchDate), "year");
			let selectedTimeFilter = this.getSelectedTimeFilterFromAge(shareAge);
			let startDate = moment().subtract((selectedTimeFilter * 12), "month");
			this.setState({ shareAge, selectedTimeFilter, startDate, launchDate: launchDate });
		}
	}

	handleTabClick(index) {
		let { appParams, shareClass } = this.props;
		addItemToGoogleTracking(appParams, "fund_page_performance_tab", { eventCategory: shareClass.clientCode, eventAction: "Performance Graph", eventLabel: PagePerformance.tabs[index] });
		this.setState({ activeTab: index });
	}

	handleSelectedTimeClick(event, time) {
		let eventLabel = `${time}Y`;
		let { shareAge, selectedTimeFilter } = this.state;
		let { shareClass, appParams } = this.props;
		if (shareAge >= time || time === 999) {
			selectedTimeFilter = time;
		}
		let startDate;
		let endDate = moment();
		if (time === 0) {
			let today = moment();
			startDate = moment().subtract(today.month(), "month");
			eventLabel = "YTD";
		}
		else if (time === 999) {
			startDate = moment(shareClass.properties["launch_date"]).format("YYYY-MM-DD");
			eventLabel = "Since Launch";
		}
		else {
			startDate = moment().subtract((selectedTimeFilter * 12), "month");
		}
		addItemToGoogleTracking(appParams, "fund_page_performance_tab_graph", { eventCategory: shareClass.clientCode, eventAction: "Performance Graph", eventLabel });
		this.setState({ selectedTimeFilter, startDate, endDate });
	}

	getFilterStyle(value) {
		let { selectedTimeFilter, shareAge } = this.state;
		return `${shareAge < value && value !== 999 ? styles.disabled : selectedTimeFilter === value ? styles.active : ""}`;
	}

	addShareToCompare(event, typeahead) {
		event.preventDefault();
		let { compare } = this.props;
		let identifier = event.target.children[0].children[0].value.split(" - ").pop();
		let [isValidISIN] = typeahead.filter(item => item.isin === identifier);

		this.checkIfAlreadyInCompare(compare, identifier);

		if (!isNullOrUndefined(isValidISIN)) {
			if (compare.length < 5) {
				this.props.addToCompare("CLSS", {
					matchtype: "MATCH",
					values: [identifier],
					property: "isin"
				});
			}
			else {
				this.showMaxCompareMessage("You can compare a maximum of 5 items. <br />Please remove one of the selected items from the list below before adding a new one.");
			}
		}
	}

	addBMToCompare(event) {
		event.preventDefault();
		let { compare } = this.props;
		let { identifier } = this.state.selectedBenchmarkSector;

		this.checkIfAlreadyInCompare(compare, identifier);

		if (!identifier && identifier === '') {
			this.showMaxCompareMessage("Please select an item before trying to add");
		}
		else if (compare.length < 5) {
			this.props.addToCompare("BMRK", {
				matchtype: "MATCH",
				values: [identifier],
				property: "client_code"
			});
		}
		else {
			this.showMaxCompareMessage("You can compare a maximum of 5 items. <br />Please remove one of the selected items from the list below before adding a new one.");
		}

		this.setState({ selectedBenchmarkSector: { identifier: "", text: "" } });
	}

	checkIfAlreadyInCompare(compare, identifier) {
		let [isAlredyInCompare] = compare.filter(item => item.clientCode === identifier);
		if (isAlredyInCompare) {
			this.showMaxCompareMessage("This item has already been selected");
		}
	}

	showMaxCompareMessage(message) {
		this.setState({ showMaxCompareMessage: true, compareMessage: { __html: message } });
		this.hideMaxCompareMessage();
	}

	hideMaxCompareMessage() {
		setTimeout(() => {
			this.setState({ showMaxCompareMessage: false });
		}, 4000);
	}

	removeFromCompare(event, identifier) {
		event.preventDefault();
		this.props.removeFromCompare(identifier);
	}

	setStartDate(date) {
		let { appParams, shareClass } = this.props;
		let { endDate } = this.state;

		const googleEvent: IGoogleEvent = {
			eventCategory: shareClass.clientCode,
			eventAction: "Performance Graph",
			eventLabel: `Custom Dates - ${moment(date).format('YYYY-MM-DD')} to ${moment(endDate).format('YYYY-MM-DD')}`
		};

		addItemToGoogleTracking(appParams, "fund_page_performance_tab", googleEvent);
		this.setState({ startDate: moment(date).startOf('month'), selectedTimeFilter: -1 });
	}

	setEndDate(date) {
		let { appParams, shareClass } = this.props;
		let { startDate } = this.state;
		addItemToGoogleTracking(appParams, "fund_page_performance_tab", { eventCategory: shareClass.clientCode, eventAction: "Performance Graph", eventLabel: `Custom Dates - ${moment(startDate).format('YYYY-MM-DD')} to ${moment(date).format('YYYY-MM-DD')}` });
		this.setState({ endDate: moment(date).subtract(10, "day").endOf('month'), selectedTimeFilter: -1 });
	}

	checkDate(current) {
		return true;

		// let { shareClass } = this.props;
		// if (shareClass) {
		//     let startDate = moment(shareClass.properties["launch_date"]).format("YYYY-MM-DD");
		//     let endDate = moment().format("YYYY-MM-DD");
		//     return moment(current).isBetween(startDate, endDate, null, '[]')
		// }
	}

	changeSelectedIndex(obj) {
		this.setState({ selectedIndex: obj.index });
	}

	selectBenchmarkSector(obj) {
		let { identifier, text } = obj;
		this.setState({ selectedBenchmarkSector: { identifier, text } })
	}

	getBenchmarkOrSectorValues(flag) {
		let { benchmarks, compare } = this.props;
		let response = benchmarks.reduce((acc: any, item: IDataEntity) => {
			let [isInCompare] = compare.filter(compareItem => compareItem.clientCode === item.clientCode);
			if (item.properties[flag] && isNullOrUndefined(isInCompare) && item.properties.name !== "NA") {
				acc.push({
					text: item.properties.name,
					value: item.properties.client_code
				});
			}
			return acc;
		}, []).sort((a, b) => {
			let aName = a.text.toUpperCase();
			let bName = b.text.toUpperCase();
			if (aName < bName) {
				return -1;
			}
			if (aName > bName) {
				return 1;
			}
			return 0;
		});

		return response;
	}

	getAnnualisedValue(entity: IDataEntity, timePeriod, code, ccy = "GBP", isChainLinked) {
		let result;
		if (!isChainLinked) {
			ccy = "GBP";
		}
		let [entityValue] = entity.statistics.filter(item => item.code === code && item.ccy === ccy);
		if (entityValue) {
			[result] = entityValue.values.filter(item => item.label === timePeriod);
		}

		return result ? result.value : 0;
	}

	getAnnualisedDate(entity: IDataEntity, timePeriod, code, ccy = "GBP", isChainLinked) {
		let result;
		if (!isChainLinked) {
			ccy = "GBP";
		}
		let [entityValue] = entity.statistics.filter(item => item.code === code && item.ccy === ccy);
		if (entityValue) {
			[result] = entityValue.values.filter(item => item.label === timePeriod);
		}

		return (result && result.as_at_date) ? result.as_at_date : "-";
	}

	checkShareAge(hideYearData, hideMonthData) {
		const { appParams } = this.props;
		const { clienttype } = appParams;
		// console.log(clienttype);
		if (hideYearData && (clienttype === "diw" || clienttype === "adv")) {
			return (
				<div className={styles.wrapper}>
					<div className={styles.performanceContainer}>
						<BackToTop styles={backToTopstyles} />
						<h2 className={styles.title + ' ' + styles.reasons}>PERFORMANCE</h2>
						<div className={styles.introduction}>
							<p>Performance cannot be shown for funds which do not have one full year of data available.<br />Please contact one of our sales teams to find out more about the performance of this fund.</p>
						</div>
					</div>
				</div>
			);
		}
		if (hideYearData && (clienttype === "pri" || clienttype === "cha")) {
			return (
				<div className={styles.wrapper}>
					<div className={styles.performanceContainer}>
						<BackToTop styles={backToTopstyles} />
						<h2 className={styles.title + ' ' + styles.reasons}>PERFORMANCE</h2>
						<div className={styles.introduction}>
							<p>Performance cannot be shown for funds which do not have one full year of data available.</p>
						</div>
					</div>
				</div>
			);
		}
		if (hideMonthData) {
			return (
				<div className={styles.wrapper}>
					<div className={styles.performanceContainer}>
						<BackToTop styles={backToTopstyles} />
						<h2 className={styles.title + ' ' + styles.reasons}>PERFORMANCE</h2>
						<div className={styles.introduction}>
							<p>Performance will not be shown for funds which do not have 30 days / one full month of data available.</p>
						</div>
					</div>
				</div>
			);
		}
	}
	static tabs = [
		'Year-to-year performance',
		'Calendar year performance',
		'Annualised performance',
		'Risk measure for the fund',
	];

	render() {
		let { selectedIndex, selectedBenchmarkSector } = this.state;
		let { shareClass, fund, appParams, filterOptions, changeFilter, filter, typeahead, compare } = this.props;
		if (compare.length === 0) {
			return null;
		}
		const shareClassCurrency = shareClass.properties.shareclass_currency_code;
		let shareAgeYears = moment().diff(moment(shareClass.properties["launch_date"]), 'years') || 0;
		let shareAgeDays = moment().diff(moment(shareClass.properties["launch_date"]), 'days') || 0;
		let hideYearData = (appParams.clienttype === "cha" || appParams.clienttype === "pri" || appParams.clienttype === "diw" || appParams.clienttype === "adv") && shareAgeYears < 1;
		let hideMonthData = (appParams.clienttype === "diw" || appParams.clienttype === "ins") && shareAgeDays < 30;

		let statsMapping = shareClass.statisticsMapping["morning_star_internal_details"];
		let startDate = moment(this.state.startDate).format("YYYY-MM-DD");
		let endDate = moment(this.state.endDate).format("YYYY-MM-DD");
		let performanceData = getPerformanceForCompare(compare, startDate, endDate);

		// console.log("performanceData", performanceData);

		let {
			labels,
			chartData,
			// tslint:disable-next-line:variable-name
			YTDData,
			trailingData,
			// tslint:disable-next-line:no-unused-variable
			latestDateForDisplay,
			latestDateForDisplayComplete,
		} = performanceData;

		let colors = ["#004f5c", "#9ea900", "#943840", "#42739b", "#cc9933"];

		let filterOneOptions: any[] = [
			// {
			// 	text: "Market indices",
			// 	value: "is_benchmark"
			// },
			{
				text: "Peer group average (IA)",
				value: "is_ia_sector"
			},
			{
				text: "Peer group average (Morningstar)",
				value: "is_sector"
			}
		];

		let filterTwoOptions = this.getBenchmarkOrSectorValues(filterOneOptions[selectedIndex].value);
		return (
			<div className={styles.wrapper}>
				{(() => {
					if (!hideMonthData && !hideYearData) {
						return (
							<div className={styles.performanceContainer}>
								<BackToTop styles={backToTopstyles} />
								<h2 className={styles.title + ' ' + styles.performance}>PERFORMANCE</h2>
								<div className={styles.introduction}>
									<p>The value of investments will fluctuate, which will cause fund prices to fall as well as rise and you may not get back the original amount you invested. The level of any income earned by the fund will fluctuate. Past performance is not a guide to future performance.</p>
								</div>
								<div className={styles.selectionRow}>
									<div className={styles.row + ' ' + styles.first}>
										<div className={styles.colXs12}>
											<div className={styles.row}>
												<div className={styles.colMd1 + ' ' + styles.colXs12 + ' '}>
													<div className={styles.heading}>
														<span>Compare</span>
													</div>
												</div>
												<div className={styles.colMd11 + ' ' + styles.colXs12 + ' '}>
													<Search
														filterOptions={filterOptions}
														changeFilter={changeFilter}
														appParams={appParams}
														filter={filter}
														typeahead={typeahead}
														isFundPage={true}
														isCompare={true}
														compareFn={this.addShareToCompare}
														styles={searchBarStyles} />
												</div>
											</div>
										</div>
									</div>
									<div className={styles.row}>
										<div className={styles.colXs12}>
											<div className={styles.row}>
												<div className={styles.colMd1 + ' ' + styles.colXs12 + ' '}>
													<div className={styles.heading}>
														<span>Select</span>
													</div>
												</div>
												<div className={styles.colMd5 + ' ' + styles.colSm5 + ' ' + styles.colXs12}>
													<CategorySelector
														filterData={filterOneOptions}
														selectFn={this.changeSelectedIndex}
														selectedIndex={selectedIndex}
														appParams={appParams} />
												</div>
												<div className={styles.colMd5 + ' ' + styles.colSm5 + ' ' + styles.colXs12 + ' ' + styles.categorySelectorContainer}>
													<CategorySelector
														filterData={filterTwoOptions}
														selectedText={selectedBenchmarkSector.text}
														selectFn={this.selectBenchmarkSector}
														appParams={appParams} />
												</div>
												<div className={styles.colMd1 + ' ' + styles.colSm1 + ' ' + styles.colXs12 + ' ' + styles.addButtonContainer}>
													<span onClick={this.addBMToCompare} className={styles.addButton}><AddBtn /></span>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className={styles.row + ' ' + styles.rangeSelector}>
									<div className={styles.colMd6}>
										<div className={styles.row}>
											<div>
												<div className={`${styles.heading} ${styles.custom}`}>
													<span>From: </span>
												</div>
											</div>
											<div>
												<Datetime
													isValidDate={this.checkDate}
													value={this.state.startDate}
													onChange={this.setStartDate}
													className="calendarPerformance"
													inputProps={{ placeholder: "From", readOnly: true }}
													timeFormat={false}
													closeOnSelect={true}
													viewMode={'months'}
													dateFormat="MM/YYYY"
												/>
											</div>
											<div>
												<div className={`${styles.heading} ${styles.custom}`}>
													<span>To: </span>
												</div>
											</div>
											<div>
												<Datetime
													isValidDate={this.checkDate}
													value={this.state.endDate}
													onChange={this.setEndDate}
													className="calendarPerformance"
													inputProps={{ placeholder: "To", readOnly: true }}
													timeFormat={false}
													closeOnSelect={true}
													viewMode={'months'}
													dateFormat="MM/YYYY"
												/>
											</div>
										</div>
									</div>
									<div className={styles.colMd6}>
										<ul>
											<li
												onClick={(event) => this.handleSelectedTimeClick(event, 0)}
												className={this.getFilterStyle(0)}>
												YTD
                                        </li>
											<li
												onClick={(event) => this.handleSelectedTimeClick(event, 1)}
												className={this.getFilterStyle(1)}>
												1Y
                                        </li>
											<li
												onClick={(event) => this.handleSelectedTimeClick(event, 3)}
												className={this.getFilterStyle(3)}>
												3Y
                                        </li>
											<li
												onClick={(event) => this.handleSelectedTimeClick(event, 5)}
												className={this.getFilterStyle(5)}>
												5Y
                                        </li>
											<li
												onClick={(event) => this.handleSelectedTimeClick(event, 10)}
												className={this.getFilterStyle(10)}>
												10Y
                                        </li>
											<li
												onClick={(event) => this.handleSelectedTimeClick(event, 999)}
												className={this.getFilterStyle(999)}>
												SINCE LAUNCH
                                        </li>
										</ul>
									</div>
								</div>
								<div className={styles.chartContainer}>
									{(() => {
										if (this.state.showMaxCompareMessage) {
											return (
												<div className={styles.maxCompareMessageContainer}>
													<p dangerouslySetInnerHTML={this.state.compareMessage}></p>
												</div>
											);
										}
									})()}
									<PerformanceChart
										data={chartData}
										labels={labels.map(label => label.label)}
										isFundPage={true}
										interval={this.getInterval(chartData)}>
									</PerformanceChart>
								</div>
								<div className={styles.row + ' ' + styles.chart}>
									<ResponsiveContainer breakpoint={960}>
										<Tabs handleClick={this.handleTabClick} activeTab={this.state.activeTab} tabs={PagePerformance.tabs} styles={overrideStyles}></Tabs>
										<Selector handleClick={this.handleTabClick} title={this.state.activeTab} options={PagePerformance.tabs} styles={selectorOverrideStyles}></Selector>
									</ResponsiveContainer>
									<TabContents activeContent={this.state.activeTab}>
										<div className={styles.row + ' ' + styles.chartdetails}>
											<div className={styles.colXs12} style={{ width: "100%" }}>
												<div className={styles.responsiveTable}>
													<table>
														<thead>
															<tr>
																<th className={styles.first}> </th>
																<th className={styles.leftAlignFloatRight}>From<br />To</th>
																{YTDData[0].map((yearData, index) => {
																	return (
																		<td key={index}>
																			{moment(yearData.start_date).format('DD.MM.YYYY')}
																			<br />
																			{moment(yearData.end_date).format('DD.MM.YYYY')}
																		</td>
																	);
																})}
															</tr>
														</thead>
														<tbody>
															{YTDData.map((ytd, index) => (
																<tr key={index} className={index === 0 ? styles.fundColumn : styles.fundRow}>
																	<td
																		style={{ backgroundColor: colors[index], color: "white" }}
																		onClick={index !== 0 ? (event) => this.removeFromCompare(event, labels[index].identifier) : (event) => event}
																		className={styles.first}>
																		{index === 0 ? "" : <CloseBtn />}
																	</td>
																	<td className={styles.fundColumn}>{labels[index].label}</td>
																	{ytd.map((yearData, index) => {
																		let value = yearData.value
																		if (value === -0.0009) {
																			value = 0;
																		}
																		return <td key={index}><NumberFormat options={{ suffix: "%" }}>{value}</NumberFormat></td>
																	})}
																</tr>
															))}
														</tbody>
													</table>
												</div>
											</div>
										</div>
										<div className={styles.row + ' ' + styles.chartdetails}>
											<div className={styles.colXs12} style={{ width: "100%" }}>
												<table>
													<thead>
														<tr>
															<th className={styles.first}> </th>
															<th className={styles.leftAlign}>Performance as at {latestDateForDisplayComplete}</th>
															{trailingData[0].map(trailData => {
																return <th key={trailData.year}>{trailData.year}</th>
															})}
														</tr>
													</thead>
													<tbody>
														{trailingData.map((trailing, index) => (
															<tr key={index} className={index === 0 ? styles.fundColumn : styles.fundRow}>
																<td
																	style={{ backgroundColor: colors[index], color: "white" }}
																	onClick={index !== 0 ? (event) => this.removeFromCompare(event, labels[index].identifier) : (event) => event}
																	className={styles.first}>
																	{index === 0 ? "" : <CloseBtn />}
																</td>
																<td className={styles.fundColumn}>{labels[index].label}</td>
																{trailing.map((trailData, index) => {
																	return <td key={index}><NumberFormat options={{ suffix: "%" }}>{trailData.value}</NumberFormat></td>
																})}
															</tr>
														))}
													</tbody>
												</table>
											</div>
										</div>
										<div className={styles.row + ' ' + styles.chartdetails}>
											<div className={styles.colXs12} style={{ width: "100%" }}>
												<table>
													<thead>
														<tr>
															<th className={styles.first}> </th>
															<th className={styles.leftAlign}></th>
															<th>Performance as at</th>
															<th>1Y</th>
															<th>3Y</th>
															<th>5Y</th>
															<th>SINCE INCEPTION</th>
														</tr>
													</thead>
													<tbody>
														{compare.map((entity, index) => {
															let code;
															let isChainLinked = false
															if (entity.properties.is_benchmark) {
																if (entity.clientCode.toUpperCase().includes("CBLT")) {
																	isChainLinked = true;
																	code = "mstar_trailing_benchmark";
																}
																else {
																	code = "mstar_trailing_benchmark_gbp";
																}
															}
															else if (entity.properties.is_sector || entity.properties.is_ia_sector) {
																code = "mstar_trailing_sector_gbp";
															}
															else {
																code = "morning_star_trailing_perf";
															}
															return (
																<tr key={index} className={index === 0 ? styles.fundColumn : styles.fundRow}>
																	<td
																		style={{ backgroundColor: colors[index], color: "white" }}
																		onClick={index !== 0 ? (event) => this.removeFromCompare(event, labels[index].identifier) : (event) => event}
																		className={styles.first}>
																		{index === 0 ? "" : <CloseBtn />}
																	</td>
																	<td className={styles.fundColumn}>{labels[index].label}</td>
																	<td>{moment(this.getAnnualisedDate(entity, "M12", code, shareClassCurrency, isChainLinked)).format('DD.MM.YYYY')}</td>
																	<td><NumberFormat options={{ suffix: "%" }}>{this.getAnnualisedValue(entity, "M12", code, shareClassCurrency, isChainLinked)}</NumberFormat></td>
																	<td><NumberFormat options={{ suffix: "%" }}>{this.getAnnualisedValue(entity, "M36", code, shareClassCurrency, isChainLinked)}</NumberFormat></td>
																	<td><NumberFormat options={{ suffix: "%" }}>{this.getAnnualisedValue(entity, "M60", code, shareClassCurrency, isChainLinked)}</NumberFormat></td>
																	<td><NumberFormat options={{ suffix: "%" }}>{this.getAnnualisedValue(entity, "M255", code, shareClassCurrency, isChainLinked)}</NumberFormat></td>
																</tr>
															);
														})}
													</tbody>
												</table>
											</div>
										</div>
										<div className={styles.row + ' ' + styles.chartdetails}>
											<div className={styles.colXs12} style={{ width: "100%" }}>
												<table>
													<thead>
														<tr>
															<th className={styles.first}> </th>
															<th colSpan={3} className={styles.leftAlign}>As at {latestDateForDisplayComplete}</th>
															<th className={styles.centerAlign}>
																<Tooltip text={"The degree to which a given security, fund, or index rapidly changes. It is calculated as the degree of deviation from the norm for that type of investment over a given time period. The higher the volatility, the riskier the security tends to be."} />
																<br />Volatility
                                                <br />3Y
                                            </th>
															<th className={styles.centerAlign}>
																<Tooltip text={"A measure of risk-adjusted return. It is calculated by dividing the difference between the return of a given portfolio and the risk-free rate by the standard deviation of the portfolio returns. The risk-free rate is a hypothetical return of an investment with zero risk. The Sharpe ratio is useful to investors as it shows return (excess over the risk-free rate) per unit of risk or the adjustment of investment performance for the risk taken by the fund manager."} />
																<br />Sharpe Ratio
                                                <br />3Y
                                            </th>
															<th className={styles.centerAlign}>
																<Tooltip text={"A measure of the sensitivity of a portfolio’s or asset’s return relative to the return of the relevant index (usually the stockmarket’s main share index). A beta of less (more) than 1.0 would suggest lower (higher) volatility than the index. Investors look to higher beta investments for higher levels of risk relative to the index. Conversely, a lower beta investment suggests a lower level of risk and thus lower expected returns than the index."} />
																<br />Beta
                                                <br />3Y
                                            </th>
															<th className={styles.centerAlign}>
																<Tooltip text={"A measure of the sensitivity of a fixed income security, also called a bond, or bond fund to changes in interest rates. The longer a bond or bond fund’s duration, the more sensitive it is to interest rate movements."} />
																<br />Duration
                                                <br />3Y
                                            </th>
														</tr>
													</thead>
													<tbody>
														<tr className={styles.fundColumn}>
															<td className={styles.first}></td>
															<td colSpan={3} className={styles.fundColumn}>{labels[0].label}</td>
															<td className={styles.centerAlign}><NumberFormat options={{ suffix: "%" }}>{safe(() => statsMapping.volatility, "")}</NumberFormat></td>
															<td className={styles.centerAlign}><NumberFormat options={{ suffix: "%" }}>{safe(() => statsMapping.sharpe, "")}</NumberFormat></td>
															<td className={styles.centerAlign}><NumberFormat options={{ suffix: "%" }}>{safe(() => statsMapping.beta, "")}</NumberFormat></td>
															<td className={styles.centerAlign}>
																{(() => {
																	if ((fund.properties.asset_class as string).toLowerCase() === "fixed income") {
																		return <NumberFormat options={{ suffix: "%" }}>{safe(() => statsMapping.duration, "")}</NumberFormat>;
																	} else {
																		return "n/a";
																	}
																})()}
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</TabContents>
								</div>
								{(() => {
									if (!isNullOrUndefined(shareClass.disclaimers["shareclass_performance"]) && !shareClass.disclaimers["shareclass_performance"][0].is_deleted) {
										return (
											<div className={styles.disclaimer}>
												<Disclaimer appParams={appParams} disclaimer={shareClass.disclaimers["shareclass_performance"]}></Disclaimer>
											</div>
										);
									}
								})()}
							</div>
						);
					} else {
						return this.checkShareAge(hideYearData, hideMonthData);
					}
				})()}
			</div>
		);
	}

	getSelectedTimeFilterFromAge(fundAge) {
		let selectedTimeFilter;
		if (fundAge <= 2) {
			selectedTimeFilter = 1;
		}
		else if (fundAge <= 4) {
			selectedTimeFilter = 3;
		}
		else if (fundAge <= 9) {
			selectedTimeFilter = 5;
		}
		else {
			selectedTimeFilter = 10;
		}

		return selectedTimeFilter;
	}

	getInterval(data) {
		let { selectedTimeFilter } = this.state;
		let interval = 0;

		if (selectedTimeFilter === 0) {
			interval = 0;
		}
		else if (selectedTimeFilter === 1) {
			interval = 1;
		}
		else if (selectedTimeFilter === 3) {
			interval = 3;
		}
		else if (selectedTimeFilter === 5) {
			interval = 5;
		}
		else if (selectedTimeFilter === 10) {
			interval = 23;
		}
		else {
			interval = Math.ceil(data.length / 11);
		}

		return interval;
	}
}


// WEBPACK FOOTER //
// ./src/client/components/PagePerformance/index.tsx